import { CSSProperties } from 'react';
import classes from './RadioButton.module.css'

interface Props {
    style?: CSSProperties;

    active?: boolean;
    onClick?: () => void;
}

const RadioButton = ({
    style,

    active = false,
    onClick = () => {},
}: Props) => {

    return (
        <button
            className="w-4 h-4 border border-gray-300 rounded-full relative"
            onClick={onClick}
            style={style}
        >
            <div className={`w-2.5 h-2.5 bg-primary rounded-full absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10 transition-transform transform ${active ? 'scale-100' : 'scale-0'}`}></div>
        </button>
    )
}

export default RadioButton